export default function EntityFieldView({ childrenFunc, required = false, disabled = false, ...field }) {
    return childrenFunc(false, field, { required, disabled });
}
